import { Pencil } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { fmtDate, fileUrl, payText } from "@/lib/api";

const slotText = (meta, slot) => meta?.slots?.find((s) => s.value === slot)?.label || slot;

const previewPayment = (b, saved) => {
  if (b.payment) return payText(b.payment);
  if (b.payment_method === "UPI") return b.upi_id ? `UPI · ${b.upi_id.slice(0, 2)}****@${b.upi_id.split("@")[1] || ""}` : payText(saved);
  if (b.payment_method === "Bank") return b.bank_account ? `Bank · ${b.bank_holder} · ****${b.bank_account.slice(-4)}` : payText(saved);
  return "Cash";
};

export const BookingSummary = ({ b, saved, onEdit }) => {
  const { t, meta, lang } = useApp();
  const rows = [
    [0, t("Scrap"), b.scrap_types.map(t).join(", ") + (b.other_text ? ` (${b.other_text})` : "") + (b.est_weight ? ` · ~${b.est_weight} kg` : "")],
    [1, t("Address"), `${b.address}${b.landmark ? ` · ${b.landmark}` : ""}`],
    [2, t("Date & time"), `${fmtDate(b.date, lang)} · ${b.slot_label || slotText(meta, b.slot)}`],
    [3, t("Payment"), t(previewPayment(b, saved))],
    [4, t("Note"), b.note || "—"],
  ];
  return (
    <div className="divide-y divide-[#EAEFEA] rounded-3xl border border-[#D2E0D8] bg-white" data-testid="booking-summary">
      {rows.map(([step, label, value]) => (
        <div key={label} className="flex items-start gap-3 p-4">
          <div className="flex-1">
            <p className="text-xs font-bold uppercase tracking-wider text-[#7B968B]">{label}</p>
            <p className="mt-0.5 break-words font-medium text-[#0D3B2B]">{value}</p>
          </div>
          {onEdit && (
            <button onClick={() => onEdit(step)} className="rounded-full p-2 text-[#2E9E6B]" data-testid={`summary-edit-${step}`}><Pencil className="h-4 w-4" /></button>
          )}
        </div>
      ))}
      {(b.photo_path || b.photo_data) && <div className="p-4"><img src={b.photo_data || fileUrl(b.photo_path)} alt="scrap" className="h-32 w-32 rounded-2xl object-cover" /></div>}
    </div>
  );
};
